/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportPromoteUploadMutationResponse, SocialExportPromoteUploadPathParams, SocialExportPromoteUpload400, SocialExportPromoteUpload401, SocialExportPromoteUpload403, SocialExportPromoteUpload404 } from "../models/SocialExportPromoteUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportPromoteUpload } from "../axios/socialExportPromoteUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportPromoteUploadMutationKey = () => [{ url: '/social-export/v1/upload/:id/promote' }] as const

export type SocialExportPromoteUploadMutationKey = ReturnType<typeof socialExportPromoteUploadMutationKey>

export function socialExportPromoteUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = socialExportPromoteUploadMutationKey()
        return mutationOptions<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, {id: SocialExportPromoteUploadPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return socialExportPromoteUpload(id, config)
          },
        })

}

/**
 * @description Promotes a scheduled upload to the front of the queue so it publishes immediately.
 * @summary Immediately publish a scheduled upload
 * {@link /social-export/v1/upload/:id/promote}
 */
export function useSocialExportPromoteUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, {id: SocialExportPromoteUploadPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportPromoteUploadMutationKey()

          const baseOptions = socialExportPromoteUploadMutationOptions(config) as UseMutationOptions<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, {id: SocialExportPromoteUploadPathParams["id"]}, TContext>
          

          return useMutation<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, {id: SocialExportPromoteUploadPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportPromoteUploadMutationResponse, ResponseErrorConfig<SocialExportPromoteUpload400 | SocialExportPromoteUpload401 | SocialExportPromoteUpload403 | SocialExportPromoteUpload404>, {id: SocialExportPromoteUploadPathParams["id"]}, TContext>
      
}